import { MenuItem, styled } from "@mui/material";

const MuiMenuItem = styled(MenuItem)(({ theme }) => {
  return {
    // "&:hover": {
    //   background: "#8c8c8c59",
    // },
    "&.Mui-selected,&:hover,&.Mui-selected:hover": {
      // "&:hover": {
      //   background: "#8c8c8c59",
      // },
      background: "#8c8c8c33",
    },
  };
});

  export default MuiMenuItem;